import React from 'react'
import "./footer.css"
import logo from "../../images/mainlogo.png"
import { IoLogoWhatsapp } from "react-icons/io";
import { FaFacebook } from "react-icons/fa";
import { IoCall } from "react-icons/io5";
import { AiFillInstagram } from "react-icons/ai";

function Footer() {
    return (
        <>
            <div className='mainFooterdiv'>

                <div className='footer1'>
                    <img src={logo} className='footerlogo' alt="Bootstrap" />
                    <div className='footersocial'>
                        <p>Social Links</p>
                        <div> <FaFacebook className='ficon' /> <AiFillInstagram id='finsta' className='ficon' /> <IoLogoWhatsapp className='ficon' /></div>
                    </div>
                </div>

                <div className='footer2'>
                    <div className='footer2inner'>
                        <h3>About Us</h3>
                        {/* <p>creativecarcare.in is an exclusive E-commerce Platform owned by Creative International. Creative International has achieved the Accreditation of being acknowledged as an Institution, in the field of Import and Distribution of Premium Car Care. Our company has been ISO 9001:2015 certified....</p> */}
                        <p>Welcome to Patrika, your one-stop online destination for unique and customizable Indian wedding cards. We offer a wide range of beautifully designed digital invitations to suit every taste, tradition, and budget. Our platform makes it easy for couples to personalize their wedding invites with creative templates, rich colors, and elegant typography...</p>
                        <a className='fReadmore'>Read More</a>
                        <div className='footerredbox'>
                            <a>For Commercial and Bulk enquiries. WhatsApp us on +91 9920290909</a>
                        </div>
                    </div>
                </div>

                <div className='footer3'>
                    <div className='footer3inner'>
                        <h3>Contact Us</h3>
                        <p>If you have any query, please contact us on <a className='femail'>support@creativecarcare.in</a></p>
                        <p>Unit 1, Janata Compound, Senapati Bapat Marg, Lower Parel West, Mumbai, India, 400013</p>
                        <div className='footerredbox'>
                            <a><IoCall size={18} /> +91 9545900009</a>
                        </div>
                    </div>
                </div>
            </div>
            <div className='fCopyright'><p>Copyright © 2025 patrika.com All rights reserved.</p></div>
        </>
    )
}

export default Footer
